<template>
    <div>
        <template v-for="(predicateItem, index) in predicateItems">
            <SrLabel
                :key="predicateItem.filterCriteria + '_label_' + index"
                :text="getLabelText(predicateItem)"
                color="blue"
                class="mt-1 mr-2 mb-1"
                action-icon="close"
                @action="remove(predicateItem)"
            />
            <SrFilterLabelOperator
                v-if="index !== predicateItems.length - 1"
                :key="predicateItem.filterCriteria + '_operator_' + index"
                :value="filterPredicate.operator"
                @input="updateOperator"
            />
        </template>
    </div>
</template>

<script>
import { Predicate } from '@ads/predicate-model';
import SrLabel from '../SrLabel/SrLabel';
import SrFilterLabelOperator from './SrFilterLabelOperator';
import PropagateInputEvent from '../../mixins/PropagateInputEvent';

export default {
    components: { SrFilterLabelOperator, SrLabel },
    mixins: [PropagateInputEvent],
    props: {
        /**
         * @model filter predicate
         */
        value: {
            type: Predicate,
            required: true,
        },
        config: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            filterPredicate: this.value.clone(),
        };
    },
    computed: {
        predicateItems() {
            return this.filterPredicate?.getChildren();
        },
    },
    watch: {
        value: {
            handler(newPredicate) {
                if (newPredicate) {
                    this.filterPredicate = newPredicate.clone();
                }
            },
            deep: true,
        },
    },
    methods: {
        getLabelText(predicateItem) {
            const propertyConfig = this.config.properties.find((property) => property.name === predicateItem.name);
            if (propertyConfig && propertyConfig.toStringConfig) {
                return predicateItem.toString(propertyConfig.toStringConfig);
            }
            return predicateItem.toString();
        },
        updateOperator(newOperator) {
            if (this.filterPredicate) {
                this.filterPredicate.operator = newOperator;
                this.emitFilterPredicate();
            }
        },
        emitFilterPredicate() {
            this.emitInput(this.filterPredicate.clone());
        },
        remove(predicateItem) {
            predicateItem.remove();
            this.emitFilterPredicate();
        },
    },
};
</script>
